export enum ContactContextLocation {
  BOOTH = "BOOTH",
  AGENDA = "AGENDA",
  OTHER = "OTHER"
}
